import { NativeStackScreenProps } from "@react-navigation/native-stack";

import { StoreProductPage } from "./StoreProductPage";
import { StoreStackNavigatorParamList } from "./StoreStackNavigator";

type Props = NativeStackScreenProps<StoreStackNavigatorParamList, "Packages">;

export const StorePackagesPage = ({ navigation, route }: Props) => {
  return (
    <StoreProductPage
      selectedPackageId={route.params?.packageId}
      onSelectedPackageClose={() =>
        navigation.setParams({ packageId: undefined })
      }
      type="STANDARD"
    />
  );
};
